import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { AtualizacaoInformacoesRiscoOperacao, JanelaAtualizacaoInformacoesRisco, SaidaLoteAtualizacaoInformacoesOperacaoDTO } from 'src/app/model/atualizacao-info-risco.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { EntradaLoteAtualizacaoInformacoesOperacao } from 'src/app/model/entrada-atualizacao-informacoes-operacao.model';

@Injectable({
  providedIn: 'root'
})
export class AtualizacaoInfoRiscoService extends FgiBackEndService<AtualizacaoInformacoesRiscoOperacao> {

  // @Override
  getNewEntity() {
    const novo = new AtualizacaoInformacoesRiscoOperacao();
    novo.dataEnvio = new Date();
    return novo; 
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/atualizacao-informacao-risco-operacao';
  }

  // nao tem no BaseEntityService pra fazer override
  getAtualizacoes(params?: any): Observable<ResultadoPaginado<AtualizacaoInformacoesRiscoOperacao>> {
    let options:any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<AtualizacaoInformacoesRiscoOperacao>>;
  }

  getOperacoesQuePrecisamSerAtualizadas(cnpjAgenteFinanceiro: string): Observable<SaidaLoteAtualizacaoInformacoesOperacaoDTO> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/agente-financeiro/${cnpjAgenteFinanceiro}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<SaidaLoteAtualizacaoInformacoesOperacaoDTO>;
  }

  getOperacoesQuePrecisamSerAtualizadasTodosAgentes(): Observable<SaidaLoteAtualizacaoInformacoesOperacaoDTO> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/agente-financeiro/todos-agentes`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<SaidaLoteAtualizacaoInformacoesOperacaoDTO>;
  }

  getJanelaAtual(): Observable<JanelaAtualizacaoInformacoesRisco> {
    let options:any = blockUi();
    return this.http.get(`${this.BASE_URL}/janela`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<JanelaAtualizacaoInformacoesRisco>;
  }

  enviarAtualizacoes(lote: EntradaLoteAtualizacaoInformacoesOperacao){
    return this.http.post(`${this.BASE_URL}`,lote).pipe(
        map(response => this.convertToType(response)),
        catchError((e) => this.handleError(e))) as Observable<any>;
  }  

}
